import { Routes } from '@angular/router';

import { PlatformComponent } from './Components/platform/platform.component';
import { HelpButtonsComponent } from './Components/help-buttons/help-buttons.component';
import { KioskComponent } from './Components/kiosk/kiosk.component';

export const routes: Routes = [
    { path: '', component: PlatformComponent },
    { path: 'kiosk', component: KioskComponent },
    { path: 'buttons', component: HelpButtonsComponent }
];